/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/25
 * @updateTime 2021/8/25
 * @decription 公共组件 =》 预览模块入口js
 */
// 标题组件
import Slogan from '@/components/common/slogan';
// 模块预览组件
import ccPreviewItem from '../preview-item/index.vue';
export default {
    name: 'cc-preview-module',
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        Slogan,
        ccPreviewItem
    },
    // 参数
    props: {
        // 模块标题
        title: String,
        // 数据预览
        data: Array,
        // 为空的数据
        emptyText: {
            type: String,
            default: '暂无数据'
        }
    },
    // 数据
    data() {
        return {
            // 当前作用域变量
            scope: {
                // 类名前缀
                prefixCls: 'fd-cc-preview-module'
            },
        };
    },
    // 计算属性
    computed: {
        /**
         * 容器类名
         * @returns {Array<String>} 类名数组
         * */
        wrapClasses() {
            return [
                this.scope.prefixCls
            ];
        }
    },
    // 监听
    watch: {},
    // 创建完成
    created() {},
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {}
};
